import { Link } from "react-bootstrap-icons";


export default function RateSummaryCard({ rate, onEdit, editable }) {
  const formatDate = (value) => {
    if (!value) return "-";

    const [year, month, day] = value.split("T")[0].split("-");
    return `${day}/${month}/${year}`;
  };


  return (
    <section className="card summary-card">
      
      {/* Header */}
      <header className="summary-header">
        <h3>Resumen del Acuerdo Tarifario</h3>
      </header>

      {/* Nombre */}
      <div className="summary-title">
        {rate.name}
      </div>

      {/* Grid */}
      <div className="summary-grid">
        <div>
          <span className="label">Número y año</span>
          <span className="value">
            {rate.number} de {rate.year}
          </span>
        </div>

        <div>
          <span className="label">Fecha de expedición</span>
          <span className="value">
            {formatDate(rate.issued_at)}
          </span>
        </div>

        <div>
          <span className="label">Vigencia</span>
          <span className="value">
            {formatDate(rate.effective_from)} - {rate.effective_to ? formatDate(rate.effective_to) : "Sin fecha fin"}
          </span>
        </div>
      </div>

      {/* Documento */}
      {rate.document_url && (
        <a
          className="summary-doc"
          href={rate.document_url}
          target="_blank"
          rel="noreferrer"
        >
          Ver documento <Link />
        </a>
      )}
    </section>
  );
}
